<template>
  <div class="indexCont">
    <div class="mainCont">
      <div class="btnArr">
        <span @click="goPage('./trainRecord')">
            <img src="../../../assets/images/common/video1.png" alt="">
            培训记录
        </span>
        <span @click="goPage('./testCert')">
            <img src="../../../assets/images/common/record2.png" alt="">
            <div>考试记录</div>
        </span>
        <span class="certificateList">
            <img src="../../../assets/images/common/list_2.png" alt="">
            证书列表
        </span>
        <el-button class="rank" type="primary" size="medium" @click="$router.push('./trainRank')">排行榜</el-button>
      </div>
      <div class="listSearch">
        <el-input
            placeholder="请输入证书编号"
            v-model="queryInfo.certNumber"
            clearable
            @clear="search()"
        >
        </el-input>
        <el-date-picker
            class="date_picker"
            v-model="dateVlaue"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        <el-button type="primary" @click="search()">搜索</el-button>
      </div>
      <div class="list_content">
        <el-table
            :data="tableData"
            stripe
            border
            style="width: 100%"
        >
            <!-- <el-table-column align="center" prop="certificateName" label="证书名称">
                <template slot-scope="scope">
                  {{scope.row.certificateName ? scope.row.certificateName:''}}
                </template>
            </el-table-column> -->
            <el-table-column align="center" prop="certNumber" label="证书编号">
            </el-table-column>
            <el-table-column align="center" prop="thingName" label="培训/考试名称">
            </el-table-column>
            <el-table-column align="center" prop="certTime" label="获取时间">
              <template slot-scope="scope">
                  {{scope.row.certTime ? scope.row.certTime:''}}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="type" label="来源">
                <template slot-scope="scope">
                  <span v-if="scope.row.type==1">培训获取</span>
                  <span v-if="scope.row.type==2">考试获取</span>
                  <span v-if="scope.row.type==3">三方证书</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="success"
                        plain
                        @click="look(url,scope.row)"
                        >预览
                    </el-button>
                    <el-button
                        size="mini"
                        type="primary"
                        plain
                        @click="downLoad(url,scope.row)"
                        >下载</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="page"
            background
            :total="total"
            :page-size="queryInfo.pageSize"
            @current-change="changePage"
            layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 移动端显示 -->
    <div class="mobileTest">
      <MobileComNav title="学习成就" url="./index"></MobileComNav>
      <div class="switchTest">
        <div @click="goPage('./trainRecord')">培训记录</div>
        <div @click="goPage('./testCert')">考试记录</div>
        <div class="active">证书列表</div>
        <div @click="goPage('./trainRank')">排行榜</div>
      </div>
      <div class="mt_cont" v-show="!isShow">
        <div class="mobileSearch">
            <div class="mobileSearch_left">
                <el-input
                    placeholder="请输入证书编号"
                    v-model="queryInfo.certNumber"
                    clearable
                    @clear="search()"
                >
                </el-input>
            </div>
            <div class="mobileSearch_right">
                <div class="chooseTime" @click="openStartTime()">选择开始时间：{{queryInfo.startTime?queryInfo.startTime.slice(0,11):''}}</div>
                <div class="chooseTime" @click="openEndTime()">选择结束时间：{{queryInfo.endTime?queryInfo.endTime.slice(0,11):''}}</div>
            </div>
            <div class="mobileSearch_right_button">
                <el-button type="primary" @click="search()">搜索</el-button>
            </div>
        </div>
        <div class="mobile_content">
            <div class="item" v-for="(item,index) in tableData" :key="index">
                <div>证书编号：{{item.certNumber}}</div>
                <div>培训/考试名称：{{item.thingName}}</div>
                <div>获取时间：{{item.certTime}}</div>
                <div class="getWay">
                    <div v-if="item.type==1">来源：培训获取</div>
                    <div v-if="item.type==2">来源：考试获取</div>
                    <div v-if="item.type==3">来源：三方证书</div>
                    <div @click="lookCertificate(item)" v-if="item.picture" class="lookCertificate">查看证书</div>
                </div>
            </div>
        </div>
      </div>
      <div class="comTxt" v-show="isShow">暂无数据</div>
    </div>
    <van-dialog v-model="startTimeShow" @confirm="startTimeSure()" @cancel="startTimecancel()" title="标题" show-cancel-button>
        <van-datetime-picker
            v-model="currentDate"
            type="datetime"
            title="选择年月日"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="chooseTime()"
            @cancel="startTimecancel()"
        />
    </van-dialog>
    <van-dialog v-model="endTimeShow" @confirm="endTimeSure()" @cancel="endTimecancel()" title="标题" show-cancel-button>
        <van-datetime-picker
            v-model="currentDate"
            type="datetime"
            title="选择年月日"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="chooseTimeEnd()"
            @cancel="endTimecancel()"
        />
    </van-dialog>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import { Toast } from 'vant';
import MobileComNav from "../../../components/mobileHead";
import moment from 'moment'
export default {
  data() {
    return {
        url:this.$config.baseApi,
        one:'',
        queryInfo:{
            current:1,
            pageSize:10,
            certNumber:'',
            startTime:'',
            endTime:''
        },
        dateVlaue:[],
        total:null,
        tableData:[],
        isShow:false,
        startTimeShow:false,
        endTimeShow:false,
        minDate: new Date(2012, 0, 1),
        maxDate: new Date(2032, 12, 31),
        currentDate: new Date(),
        swiperList:[]
    };
  },
  watch:{
    dateVlaue(newVal) {
        this.queryInfo.startTime = newVal ? newVal[0] : ''
        this.queryInfo.endTime = newVal ? newVal[1] : ''
    },
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  components: {
    MobileComNav,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  created() {
    this.getCertPage()
    this.getPCorMobile()
  },
  methods: {
    getPCorMobile() {
         if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
            this.mobileGetCertPage()
         } else {
            this.getCertPage()
         }
    },
    // 证书列表
    getCertPage() {
      this.$ajax({
          url:this.$config.baseApi + "/account/staff/user/certPage",
          method:'post',
          data: {
            certNumber:this.queryInfo.certNumber,
            startTime:this.queryInfo.startTime,
            endTime:this.queryInfo.endTime,
            current:this.queryInfo.current,
            pageSize:this.queryInfo.pageSize,
          }
      }).then(res=>{
          if(res.code==1) {
            this.tableData = res.data.records
            this.total = res.data.total
          }
      }).catch(err =>{
          console.log(err)
      })
    },
    // 证书列表
    mobileGetCertPage() {
      this.$ajax({
          url:this.$config.baseApi + "/account/staff/user/certPage",
          method:'post',
          data: {
            certNumber:this.queryInfo.certNumber,
            startTime:this.queryInfo.startTime,
            endTime:this.queryInfo.endTime,
          }
      }).then(res=>{
          if(res.code==1) {
            this.tableData = res.data.records
          }
      }).catch(err =>{
          console.log(err)
      })
    },
     // 分页改变
    changePage(pageIndex) {
      this.queryInfo.current = pageIndex;
      this.getCertPage();
    },
    goPage(url) {
      this.$router.push(url);
    },
    look(url,row) {
        let imgs = row.picture
        let imgSrc = url + imgs
        if(imgs) {
            window.open(imgSrc, '_blank')
        } else {
            this.$message({
                message: '暂无证书',
            });
        }
    },
    downLoad(urls,row) {
      console.log(urls);
        let imgs = row.picture
        if(imgs) {
            let url = urls + imgs
            let name = imgs
            fetch(url).then(res => res.blob().then(blob => {
                var a = document.createElement('a');
                var url = window.URL.createObjectURL(blob);
                var filename = name || '';
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }));
        } else {
            this.$message({
                message: '暂无证书',
            });
        }
    },
    // downLoad(urls,row) {//下载图片地址和图片名
    //   // let url = urls + row.picture
    //   var image = new Image();
    //   // 解决跨域 Canvas 污染问题
    //   image.setAttribute("crossOrigin", "anonymous");
    //   image.onload = function() {
    //     var canvas = document.createElement("canvas");
    //     canvas.width = image.width;
    //     canvas.height = image.height;
    //     var context = canvas.getContext("2d");
    //     context.drawImage(image, 0, 0, image.width, image.height);
    //     var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

    //     var a = document.createElement("a"); // 生成一个a元素
    //     var event = new MouseEvent("click"); // 创建一个单击事件
    //     a.download = name || "photo"; // 设置图片名称
    //     a.href = url; // 将生成的URL设置为a.href属性
    //     a.dispatchEvent(event); // 触发a的单击事件
    //   };
    //   image.src = urls + row.picture
    // },
    search() {
        this.getCertPage()
    },
    // 开始时间
    openStartTime() {
        this.startTimeShow = true
    },
    chooseTime() {
      let time = moment(this.currentDate).format('YYYY-MM-DD HH:mm:ss')
      this.queryInfo.startTime = time
    },
    startTimeSure() {
        this.startTimeShow = false
    },
    startTimecancel() {
        this.startTimeShow = false
        this.queryInfo.startTime = ''
    },
    // 结束时间
    openEndTime() {
        this.endTimeShow = true
    },
    chooseTimeEnd() {
      let time = moment(this.currentDate).format('YYYY-MM-DD HH:mm:ss')
      this.queryInfo.endTime = time
    },
    endTimeSure() {
        this.endTimeShow = false
    },
    endTimecancel() {
        this.endTimeShow = false
        this.queryInfo.endTime = ''
    },
    // 查看证书
    lookCertificate(item) {
        this.swiperList = []
        let imgs = item.picture
        this.swiperList.push(this.url + imgs)
        this.preview()
    },
    preview() {
        ImagePreview({
           images: this.swiperList,
        });
    },
  }
};
</script>

<style scoped>
@import "../../../assets/css/home/test.css";
.mainCont {
  background: #fff;
  padding: 0.23rem 0.2rem;
  margin-bottom: 0.2rem;
}
.gayBtn{
  background:#909399;
}
.btnArr{
    border-bottom: 1px solid #e8e8e8;
    position: relative;
}
.btnArr .rank{
  position: absolute;
  top:0;
  right:0;
}
.btnArr span{
    display: inline-block;
    height: 0.42rem;
    width:1.2rem;
    line-height: 0.42rem;
    text-align: center;
    cursor: pointer;
}
.btnArr span img{
    height: 0.15rem;
}
.btnArr span:nth-child(2){
    position: relative;
}
.btnArr span:nth-child(2) div{
    margin-left:0.15rem;
}
.btnArr span:nth-child(2) img{
    height: 0.16rem;
    position: absolute;
    top: 0.13rem;
    left: 0.14rem;
}
.btnArr span:nth-child(3){
    border-bottom:0.03rem solid #417ccb;
    color:#417ccb;
    margin-right:0.1rem;
}
.txtTotal{
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #417ccb;
}
.txtTotal div{
  margin-left:0.2rem;
  font-size:0.16rem;
  display: flex;
  align-items: center;
}
.txtTotal div img{
  display:block;
  height: 0.2rem;
  margin-right:0.04rem;
}
.listSearch {
    display: flex;
}
.listSearch {
  margin-top:0.2rem;
}
.listSearch .el-input {
    width: 15%;
}
.date_picker {
    margin: 0 .1rem;
}
.list_content {
    margin-top: .2rem;
}
.list_content .page{
    margin-top: .2rem;
}
.certificateList img{
    vertical-align: middle;
    margin-top: -.03rem;
}

@media screen and (max-width: 768px) {
  .mainCont {
    display: none;
  }
  .mobileTest {
    display: block;
  }
  .comSearch{
    display: block;
    margin-top:0.2rem;
  }
  .mobileSearch{
      padding:0.2rem 5%;
      background:#fff;
      border-radius: 4px;
      margin-top:0.2rem;
  }
  .mobileSearch .el-autocomplete{
      width: 67%;
  }
  .mobileTxtTotal{
    margin-top:0.2rem;
    font-size:0.28rem;
    display:flex;
    justify-content: space-between;
    color:#417ccb;
  }
  .mobileTxtTotal div{
    margin:0.1rem 0;
    display: flex;
    align-items: center;
  }
  .mobileTxtTotal div img{
    display:block;
    height: 0.4rem;
    margin-right:0.15rem;
  }
  .mobileSearch .mobileSearch_right .el-date-editor{
    width: 100%;
    margin-left: 0;
    margin-top: .1rem;

  }
  .mobileSearch_right .chooseTime {
    height: .8rem;
    line-height: .8rem;
  }
  .mobile_content {
    margin: .2rem 0;
  }
  .mobile_content .item{
    padding: 0.2rem 5%;
    background: #fff;
    margin-bottom: .2rem;
  }
  .mobile_content .item .title {
    font-size: 0.36rem;
    font-weight: 500;
    line-height: 0.7rem;
  }
  .mobile_content .item .getWay {
    display: flex;
    justify-content: space-between;
  }
  .mobile_content .item .getWay .lookCertificate{
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: .1rem;
    font-size: .3rem;
    height: .5rem;
    width: 1.5rem;
    background-color: #409eff;
    color: #fff;
  }
}
</style>
